export default "__VITE_ASSET__BLTFr_G2__"